import React, {Component} from 'react'
import {Link} from 'react-router'
import {style, media, merge, hover} from 'glamor'
import {TimelineMax, TweenMax} from 'gsap'
import * as colors from '../colors'
import {findDOMNode} from 'react-dom'


class MenuLink extends Component {

  shouldComponentUpdate(){
    return false
  }

  componentWillReceiveProps(newProps){
    if(this.props.isActive !== newProps.isActive){
      this.update(newProps)
    }
  }

  update(props){


    TweenMax.to(this.refs.activeText, 0.2, {
      color: props.isActive ? (this.props.activeColor || colors.darkGray) : (this.props.normalColor || colors.lightSilver),
      // delay: props.isActive ?  0.1 : 0,
      ease: TweenMax.Cubic.easeInOut
    })
    // TweenMax.to(this.refs.normalText, 0.5, {
    //   y: props.isActive ? '-100%' : '0%',
    //   opacity: props.isActive ? 0 : 1,
    //   ease: TweenMax.Cubic.easeInOut
    // })
    TweenMax.fromTo(this.refs.border, 0.5, {
      x: props.isActive ? '-100%' : '0%',
    }, {
      x: props.isActive ? '0%' : '100%',
      delay: props.isActive ?  0.0 : 0,
      ease: TweenMax.Quart.easeInOut
    })

    if(!props.isActive){
      TweenMax.to(this.refs.underline, 0.3, {
        x: '100%',
        ease: TweenMax.Cubic.easeOut
      })
    }
  }

  roll(test){
    // TweenMax.to(this.refs.activeText, 0.5, {
    //   color: active ? (this.props.activeColor || colors.darkGray) : (this.props.normalColor || colors.lightSilver),
    //   // delay: active ?  0.1 : 0,
    //   ease: TweenMax.Cubic.easeInOut
    // })
    // TweenMax.to(this.refs.normalText, 0.5, {
    //   y: active ? '-100%' : '0%',
    //   opacity: active ? 0 : 1,
    //   ease: TweenMax.Cubic.easeInOut
    // })

    if(test) {
      const tl = new TimelineMax()
      tl
        .fromTo(this.refs.underline, 0.3, {
          x: '-100%'
        }, {
          x: '0%',
          ease: TweenMax.Quart.easeOut
        })
        .to(this.refs.underline, 0.3, {
          x: '100%',
          ease: TweenMax.Quart.easeOut
        })
    }

  }



  render(){
    const {
      text,
      activeColor= colors.darkGray,
      borderColor= colors.yellow,
      normalColor= colors.lightSilver,
      underlineColor= colors.lightSilver,
      onClick,
      href,
      ...props
    } = this.props

    return (
      <a
        onMouseEnter={(e)=>{
          e.preventDefault()
          this.roll(true)
        }}
        onMouseLeave={(e)=>{
          e.preventDefault()
          this.roll(false)
          }}
        onClick={(e)=>{
          onClick(e)
          if(typeof this.props.onItemClick === 'function'){
            this.props.onItemClick(e)
          }
        }}
        href={href}
        {...style({
          display: 'block',
          color: 'inherit',
          overflow: 'hidden',
          position: 'relative',
          width: '100%',
          textDecoration: 'none',
        })}
      >
          <div
          {...style({
            display: 'inline-block',
            position: 'relative',
            overflow: 'hidden',
            margin: '0.35rem 0',
          })}
          >
          <div
            ref='activeText'
            {...style({
              padding: '0.1rem 0',
              fontSize: '1.125rem',

              // color: activeColor,
              display: 'inline-block',
              willChange: 'transform',

            })}

            style={{
              color: this.props.isActive ? activeColor : normalColor,
              // opacity: this.props.isActive  ? 1 : 1,
              // transform:`translate3d(0, ${this.props.isActive ? '0%' : '100%'}, 0)`,
            }}
          >

            {text}
          </div>

          <div
            ref='underline'
            {...merge(
              style({
                display: 'none'
              }),
              media('(min-width: 600px)', {
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: 2,
                background: underlineColor,
                color: 'inherit',
                zIndex: 1,
                transform:`translate3d(100%, 0, 0)`,
                willChange: 'transform',
                display: 'block'
              })
            )}
          />


        <div
          ref='border'
          {...style({
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: 2,
            background: borderColor,
            color: 'inherit',
            zIndex:2,
            transform:`translate3d(${this.props.isActive ? '0%' : '-100%'}, 0, 0)`,
            willChange: 'transform',
          })}
        />
        </div>
      </a>
    )
  }
}


export default class Menu extends Component {

  constructor(props){
    super(props)
    this.handleItemClick = this.handleItemClick.bind(this)
  }

  shouldComponentUpdate(){
    return false
  }


  handleItemClick(){
    const node = findDOMNode(this)
    node.style.pointerEvents = 'none'
    setTimeout(()=>{
      if(this.props.onItemClick)
        this.props.onItemClick()
    }, 400)

    setTimeout(()=>{
      node.style.pointerEvents = 'auto'
    }, 600)
  }

  render(){
    return (
      <div
        {...style({
          width: '100%'
        })}
      >
        {this.props.pages.map((page, i)=>(
          <Link key={page.url} to={page.url}>
          {
            (props) => (
              <MenuLink
                onItemClick={this.handleItemClick}
                activeColor={this.props.activeColor}
                normalColor={this.props.normalColor}
                borderColor={this.props.borderColor}
                underlineColor={this.props.underlineColor}
                {...props}
                isActive={page.isExact ?  props.currentLocation.pathname === page.url : props.isActive}
                text={page.title}
              />
          )}
          </Link>
        ))}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Menu.js
 **/